import { requestApi } from "../apiService";
import { ApiEndpoints } from "../apiEndpoints";
import { EncryptedPasswordData, EncryptedUserData } from "../types/user";

export const getUserData = async (
  userName: string,
  signal?: AbortSignal,
): Promise<EncryptedUserData> => {
  const response = await requestApi({
    url: ApiEndpoints.USERS,
    method: "GET",
    params: {
      username: userName,
    },
    signal,
  });

  return response.data;
};

export const patchUserData = async (
  payload: EncryptedUserData,
): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.USERS,
    method: "PATCH",
    data: payload,
  });
};

export const deleteAccount = async (): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.USERS,
    method: "DELETE",
  });
};

/**
 * Account deletion v2 — `DELETE /umbra/v2/users/me` (bearer-authenticated, no
 * body; always the token's own account). 204 on success; failures arrive as
 * RFC 9457 problem details, surfaced by requestApi as an ApiError whose
 * `data.title` is prefixed `errors.Account.*` — branch on that, never on
 * `detail` prose. Used when featureFlags.accountDeletionV2 is on; the legacy
 * `deleteAccount` above stays for the flag-off path.
 */
export const deleteOwnAccount = async (): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.DELETE_ACCOUNT,
    method: "DELETE",
  });
};

export const userExists = async (
  username: string,
  signal?: AbortSignal,
): Promise<boolean> => {
  const response = await requestApi({
    url: `${ApiEndpoints.USER_EXISTS}`,
    method: "GET",
    params: {
      username: username,
    },
    signal,
  });

  if (response.status === 200) {
    return true;
  }
  return false;
};
export const getEncryptedPassword = async (
  username: string,
  signal?: AbortSignal,
): Promise<EncryptedPasswordData> => {
  const response = await requestApi({
    url: `${ApiEndpoints.ENCRYPTED_PASSWORD}`,
    method: "GET",
    params: {
      username: username,
    },
    signal,
  });

  return response.data;
};
